import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const EMPTY = Object.freeze({
  notice: null,
  setSourceNotice: () => {},
  clearSourceNotice: () => {},
});

const SourceNoticeContext = createContext(EMPTY);

export function SourceNoticeProvider({ children }) {
  const [notice, setNotice] = useState(null);

  const setSourceNotice = useCallback((next) => {
    setNotice(next ?? null);
  }, []);

  const clearSourceNotice = useCallback(() => {
    setNotice(null);
  }, []);

  const value = useMemo(
    () => ({ notice, setSourceNotice, clearSourceNotice }),
    [clearSourceNotice, notice, setSourceNotice]
  );

  return (
    <SourceNoticeContext.Provider value={value}>
      {children}
    </SourceNoticeContext.Provider>
  );
}

export function useSourceNotice() {
  return useContext(SourceNoticeContext).notice;
}

export function useSourceNoticeRegistration(notice) {
  const { setSourceNotice, clearSourceNotice } = useContext(SourceNoticeContext);

  useEffect(() => {
    if (!notice) {
      clearSourceNotice();
      return undefined;
    }

    setSourceNotice(notice);
    return undefined;
  }, [clearSourceNotice, notice, setSourceNotice]);
}
